import { createContext, useContext } from "react";

import type { Conversation } from "../types";

interface ChatContextType {
  activeConversation: Conversation | undefined;
  setActiveConversation: (urn: string, accountId: string) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatContextProvider = ChatContext.Provider;

export function useChatContext() {
  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return context;
}
